<div class="control-list">
    <span *ngFor="let obj of config">
        <button (click)="obj.onClick()" mat-raised-button *ngIf="obj.isMatRaisedButton">{{obj.title}}</button>
        <button (click)="obj.onClick()" mat-button *ngIf="obj.isMatButton">{{obj.title}}</button>
    </span>
</div>